import type { NullableFields } from "../types";

/**
 * This function merges the default settings with the scope settings.
 * @param defaultSettings
 * @param scopeSettings
 * @returns
 */
export function mergeSettings<T extends object>(
	_defaultSettings: T | Array<T>,
	_scopeSettings: T | Array<T> | null,
) {
	const defaultSettings = Array.isArray(_defaultSettings) ? _defaultSettings[0] : _defaultSettings;
	const scopeSettings = Array.isArray(_scopeSettings) ? _scopeSettings[0] : _scopeSettings;

	if (!defaultSettings) return null;
	if (!_scopeSettings) return defaultSettings as T;
	const mergedObject: T = {} as T;

	for (const key in scopeSettings) {
		const scopeValue = scopeSettings[key];

		if (scopeValue) mergedObject[key] = scopeValue;
		else mergedObject[key] = defaultSettings[key];
	}

	return mergedObject as NullableFields<T>;
}
